<template>
  <div class="wt2-sg wt2-modal-inner wt-transition-choose-modal">
    <div class="-header">
      <div class="-title">
        <div class="line-height-normal title wt2-text-l3">
          {{ 'transition.TITLE' | culture }}
        </div>
        <div class="line-height-normal sub-title wt2-text-s">
          {{ 'transition.SUB_TITLE' | culture }}
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="wt2-text-n title">
        {{ 'transition.SELECT_STYLE' | culture }}
      </div>
      <div class="transitions-display">
        <animation-item
          v-for="(transition, i) in transitionPresets"
          :key="i"
          :anim="{
            displayText: transition.name,
            icon: transition.icon,
          }"
          :selected="transition.name === selectName"
          :autoscroll="false"
          @click="selectName = transition.name"
        />
      </div>
    </div>
    <footer class="-footer -actions">
      <span
        v-if="!autoShuffle || selectName !== currentTransition"
        class="wt2-text-s -replace-text"
      >
        <span class="-red">{{ 'generic.NOTE' | culture }}</span
        >: {{ 'transition.REPLACE_EXISTING' | culture }}
      </span>
      <div class="-spring">&nbsp;</div>
      <wt-button
        :text="'generic.CANCEL' | culture"
        type="default"
        class="-min-width-unset transparent"
        @click="closeModal()"
      />
      <wt-button
        :text="'generic.APPLY' | culture"
        type="primary"
        @click="selectTransition(selectName)"
      />
    </footer>
  </div>
</template>

<script>
import AnimationItem from 'v/AssetEditor/functionality/Animation/AnimationItem.vue';

export default {
  store() {
    return app.rootStore;
  },
  components: {
    'animation-item': AnimationItem,
  },
  methods: Object.assign({
    selectTransition(transitionName) {
      this.closeModal(
        transitionName !== this.currentTransition || !this.autoShuffle
          ? { transitionName }
          : {}
      );
    },
  }),
  created() {
    this.selectName = this.currentTransition;
  },
  data() {
    return {
      selectName: null,
      KeepManually: true,
    };
  },
  props: {
    transitionPresets: {
      require: true,
      type: Array,
    },
    currentTransition: {
      type: String,
      require: true,
    },
    autoShuffle: {
      type: Boolean,
      require: true,
    },
    closeModal: { type: Function },
  },
};
</script>

<style lang="scss" scoped>
.-replace-text {
  .-red {
    color: red;
  }

  position: absolute;
  left: 25px;
  bottom: 15px;
}

.wt2-modal-inner.wt-transition-choose-modal {
  max-height: 530px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding: 20px 20px 100px;

  .title {
  }

  .sub-title {
    margin-top: 7px;
  }

  .line-height-normal {
    line-height: normal;
  }

  .modal-body {
    padding: 0;

    .title {
      margin: 30px 0 15px;
    }

    .transitions-display {
      &::after {
        content: '';
        width: 33%;
      }

      height: 300px;
      display: grid;
      grid-template-columns: 240px 240px 240px;
      grid-template-rows: 138px 1fr;
      grid-row-gap: 20px;
      overflow-y: auto;
      justify-content: center;
      align-content: space-between;
      justify-content: space-between;
      overflow: visible;
      overflow-y: auto;
      padding-bottom: 2px;

      .-item {
        position: relative;
        display: flex;
        width: 240px;
        height: 138px;
        //margin: 6px;
        transition: border-width 0.2s linear;
        border: 0px solid #ffffff;

        &.-selected {
          outline: 2px solid #06a9f4;
          border: 15px solid #ffffff;
          overflow: hidden;
          width: 236px;
          height: 134px;
          margin-left: 2px;
          margin-top: 2px;
        }
        &:hover {
          /deep/ .-label {
            opacity: 0;
          }
          &:not(.-selected) {
            cursor: pointer;
            border: 4px solid #ffffff;
            outline: 2px solid #06a9f4;
            width: 236px;
            height: 134px;
            margin-left: 2px;
            margin-top: 2px;
            overflow: hidden;
          }
        }
      }

      .-item /deep/ video {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
      }

      .-item /deep/ .-label {
        margin: auto;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.5s ease-out;
      }
    }
  }

  > .-footer {
    > .wt2-check-box-component {
      width: 40%;
      margin: auto 0 auto 20px;
    }
  }
}
</style>
